export default "__VITE_ASSET__CE5X$sad__"